module.exports = __webpack_public_path__ + "img/bg_xwzx.ae9fb159.jpg";